import Vue from 'vue'
import VueRouter from 'vue-router'
// import Pages from '../views/pages/pages.vue'
import Index from '../views/index/index.vue'

Vue.use(VueRouter)

const routes = [
	
	{
		path: '/',
		name: 'signin',
		component: () =>
			import('@/views/signup/signin'), //登录
	},
	{
		path: '/homepage',
		name: 'index',
		component: Index
	},
	{
		path: '/list',
		name: 'list',
		component: () =>
			import('@/views/list/list'), //列表
	},
	{
		path: '/pages/goods/goods',
		name: 'details',
		component: () =>
			import('@/views/details/details'), //详情
	},
	{
		path: '/tjDetail',
		name: 'tjDetail',
		component: () =>
			import('@/views/tjDetail/tjDetail'), //天津
	},
	{
		path: '/zzDetail',
		name: 'zzDetail',
		component: () =>
			import('@/views/zzDetail/zzDetail'), //天津
	},
	{
		path: '/hbDetail',
		name: 'hbDetail',
		component: () => import('@/views/hbDetail/hbDetail'), //河北
	},
	
	{
		path: '/sdDetail',
		name: 'sdDetail',
		component: () => import('@/views/sdDetail/sdDetail'), //山东
	},
	{
		path: '/cat',
		name: 'cat',
		component: () =>
			import('@/views/cat/cat'), //购物车
	},
	{
		path: '/submitOrder',
		name: 'submitOrder',
		component: () =>
			import('@/views/submitOrder/submitOrder'), //提交订单
	},
	{
		path: '/shop',
		name: 'shop',
		component: () =>
			import('@/views/shop/shop'), //提交订单
	},
	{
		path: '/shopClassify',
		name: 'shopClassify',
		component: () =>
			import('@/views/shop/shopClassify'), //提交订单
	},
	{
		path: '/ttshop_user',
		name: 'ttshop_user',
		component: () =>
			import('@/views/user/ttshop_user'), //个人中心
	},
	{
		path: '/ttshop_usermyorder',
		name: 'ttshop_usermyorder',
		component: () =>
			import('@/views/user/ttshop_usermyorder'), //我的订单
	},
	{
		path: '/ttshop_orderxq',
		name: 'ttshop_orderxq',
		component: () =>
			import('@/views/user/ttshop_orderxq'), //待支付订单
	}, ,
	{
		path: '/ttshop_usernews',
		name: 'ttshop_usernews',
		component: () =>
			import('@/views/user/ttshop_usernews'), //个人信息
	},
	{
		path: '/ttshop_security',
		name: 'ttshop_security',
		component: () =>
			import('@/views/user/ttshop_security'), //修改密码
	},
	{
		path: '/ttshop_siterun',
		name: 'ttshop_siterun',
		component: () =>
			import('@/views/user/ttshop_siterun'), //地址管理
	},
	{
		path: '/ttshop_accountaq',
		name: 'ttshop_accountaq',
		component: () =>
			import('@/views/user/ttshop_accountaq'), //账户安全
	},
	{
		path: '/ttshop_mybalance',
		name: 'ttshop_mybalance',
		component: () =>
			import('@/views/user/ttshop_mybalance'), //我的余额
	},
	{
		path: '/ttshop_recharge',
		name: 'ttshop_recharge',
		component: () =>
			import('@/views/user/ttshop_recharge'), //余额充值
	},
	{
		path: '/ttshop_coupon',
		name: 'ttshop_coupon',
		component: () =>
			import('@/views/user/ttshop_coupon'), //我的优惠券
	},
	{
		path: '/ttshop_integral',
		name: 'ttshop_integral',
		component: () =>
			import('@/views/user/ttshop_integral'), //我的积分
	},
	{
		path: '/ttshop_barter',
		name: 'ttshop_barter',
		component: () =>
			import('@/views/user/ttshop_barter'), //我要换货/退货
	},
	{
		path: '/ttshop_barteragree',
		name: 'ttshop_barteragree',
		component: () =>
			import('@/views/user/ttshop_barteragree'), //我要换货/退货(商家同意后)
	},
	{
		path: "/pages/alibaba/orderRefund/orderRefund",
		name: "orderRefund",
		component: () =>
			import('@/views/user/orderRefund'), //1688的退货界面
	},
	{
		path: '/ttshop_darterttdelivery',
		name: 'ttshop_darterttdelivery',
		component: () =>
			import('@/views/user/ttshop_darterttdelivery'), //我要换货/退货(商家发货)
	},
	{
		path: '/ttshop_evaluate',
		name: 'ttshop_evaluate',
		component: () =>
			import('@/views/user/ttshop_evaluate'), //评价
	},
	{
		path: '/ttshop_mycollection',
		name: 'ttshop_mycollection',
		component: () =>
			import('@/views/user/ttshop_mycollection'), //我的收藏
	},
	{
		path: '/ttshop_store',
		name: 'ttshop_store',
		component: () =>
			import('@/views/user/ttshop_store'), //关注的店铺
	},
	{
		path: '/ttshop_invoice',
		name: 'ttshop_invoice',
		component: () =>
			import('@/views/user/ttshop_invoice'), //我的发票
	},
	{
		path: '/ttshop_invoicexq',
		name: 'ttshop_invoicexq',
		component: () =>
			import('@/views/user/ttshop_invoicexq'), //我的发票详情
	},
	{
		path: '/ttshop_invoiceInformation',
		name: 'ttshop_invoiceInformation',
		component: () =>
			import('@/views/user/ttshop_invoiceInformation'), //发票信息
	},
	{
		path: '/ttshop_invoiceIfdetails',
		name: 'ttshop_invoiceIfdetails',
		component: () =>
			import('@/views/user/ttshop_invoiceIfdetails'), //发票信息详情
	},
	{
		path: '/ttshop_addinvoice',
		name: 'ttshop_addinvoice',
		component: () =>
			import('@/views/user/ttshop_addinvoice'), //新增发票抬头
	},
	// {
	// 	path: '/signin',
	// 	name: 'signin',
	// 	component: () =>
	// 		import('@/views/signup/signin'), //登录
	// },
	{
		path: '/binding',
		name: 'binding',
		component: () =>
			import('@/views/signup/binding'), //绑定手机号
	},
	{
		path: '/register',
		name: 'register',
		component: () =>
			import('@/views/signup/register'), //注册
	},
	{
		path: '/password',
		name: 'password',
		component: () =>
			import('@/views/signup/password'), //注册
	},
	{
		path: '/ttshop_details',
		name: 'ttshop_details',
		component: () =>
			import('@/views/signup/ttshop_details'), //详情页
	},
	{
		path: '/seckill',
		name: 'seckill',
		component: () =>
			import('@/views/seckill/seckill'), //秒杀
	},
	{
		path: '/apply',
		name: 'apply',
		component: () =>
			import('@/views/mch/apply'), //商家入驻
	},
	{
		path: '/payment',
		name: 'payment',
		component: () =>
			import('@/views/mch/payment'), //商家入驻缴纳保障金
	},
	{
		path: '/shopstore',
		name: 'shopstore',
		component: () =>
			import('@/views/shop/shopStore'), //店铺街
	},
	{
		path: '/allsort',
		name: 'allsort',
		component: () =>
			import('@/views/allsort/allsort'), //全部分类
	},
	{
		path: '/integral',
		name: 'integral',
		component: () =>
			import('@/views/integral/index'), //积分首页
	},
	{
		path: '/integral_details',
		name: 'integral_details',
		component: () =>
			import('@/views/integral/details'), //积分详情
	},
	{
		path: '/integral_submit_order',
		name: 'integral_submit_order',
		component: () =>
			import('@/views/integral/submitOrder'), //积分详情
	},
	{
		path: '/integral_order_list',
		name: 'integral_order_list',
		component: () =>
			import('@/views/integral/orderList'), //积分订单列表
	},
	{
		path: '/integral_order_details',
		name: 'integral_order_details',
		component: () =>
			import('@/views/integral/orderDetails'), //积分订单详情
	},
	{
		path: '/integral_detail',
		name: 'integral_detail',
		component: () =>
			import('@/views/user/integral_detail'), //积分明细
	},
	{
		path:'/stencil',
		name: 'stencil',
		component: ()=>
			import('@/views/stencil/stencil'),		//模板
	},
	{
		path:'/paidSer',
		name: 'paidser',
		component: ()=>
			import('@/views/paidSer/paidserve'),		//模板
	}
]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject){
		return originalPush.call(this, location, onResolve, onReject);
	}
	return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace;;
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch(err => err);
};
const router = new VueRouter({
	// mode: 'history',
	mode: 'hash',
	routes
})

export default router